// Tracks open modals by render order.
// The highest open number decides which modal is on top.
export function createModalStack() {
  let last = 0;
  const open = new Set();
  return {
    next() { last += 1; return last; },
    open(n) { open.add(n); },
    close(n) { open.delete(n); },
    isTop(n) { return open.has(n) && n === Math.max(...open); },
  };
}

export const modalStack = createModalStack();
